import React from 'react'
import PhoneInputWithCountrySelect from 'react-phone-number-input'
import CustomPhoneInput from 'components/PhoneNumberInput/PhoneInput'
import CustomCountrySelect from 'components/PhoneNumberInput/CountryDropdown'
import 'react-phone-number-input/style.css'

const PhoneNumberInput = (props) => {
  return (
    <PhoneInputWithCountrySelect
      {...props}
      inputComponent={CustomPhoneInput}
      countrySelectComponent={CustomCountrySelect}
    />
  )
}

export default PhoneNumberInput
